import useGetProductWiseReport from '../hooks/useGetProductWiseReport'
import {ProductWiseReportContext} from '../context'
import {Pagination} from '../../../utils/pagination'
import {KTCard} from '../../../_metronic/helpers'
import ProductWiseReportHeader from '../sections/header/ProductWiseReportHeader'
import ProductWiseReportTable from '../sections/table/ProductWiseReportTable'
import {useGetClassificationsDropdown} from '../hooks/useGetClassificationsDropdown'
import {useGetProductsDropdown} from '../hooks/useGetProductsDropdown'
import { useGetSupplierDropdown } from '../hooks/useGetSupplierDropdown'
import useGetProfitTrend from '../hooks/useGetProfitTrend'

function ProductWiseReport() {
  const {
    reportData,
    isLoading,
    onSearch,
    filters,
    onSortingChange,
    onPageChange,
    pagination,
    onDateChangeCustomers,
    onChangeClassificationFilter,
    onChangeSupplierFilter,
    onChangeProductFilter,
    onDownloadCSV,
  } = useGetProductWiseReport()

  const {classifications, isLoading: isClassificationsDropdownLoading} =
    useGetClassificationsDropdown()

  const {suppliers, isLoading: isSuppliersDropdownLoading} = useGetSupplierDropdown()

  const {
    products,
    pagination: productsPagination,
    isLoading: isProductsLoading,
    onPageChange: onProductsFilterPageChange,
    onSearch: onProductsFilterSearch,
    onClassificationChange: onProductsFilterClassificationChange,
  } = useGetProductsDropdown()

  const {
    profitTrendChartData,
    kpiData: profitTrendKpiData,
    weeklyBreakdownData: profitTrendWeeklyBreakdownData,
    isLoading: isProfitTrendDataLoading,
    onProfitTrendIdChange,
  } = useGetProfitTrend('product')

  const contextValue = {
    reportData,
    isLoading,
    onSearch,
    filters,
    onSortingChange,
    onPageChange,
    onDateChangeCustomers,

    classifications,
    isClassificationsDropdownLoading,
    suppliers,
    isSuppliersDropdownLoading,
    products,
    productsPagination,
    isProductsLoading,
    onProductsFilterPageChange,
    onProductsFilterSearch,
    onProductsFilterClassificationChange,
    onChangeClassificationFilter,
    onChangeSupplierFilter,
    onChangeProductFilter,
    onDownloadCSV,

    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,
  }

  return (
    <KTCard>
      <ProductWiseReportContext.Provider value={contextValue}>
        <ProductWiseReportHeader />
        <ProductWiseReportTable />
        <Pagination pagination={pagination} onPageChange={onPageChange} />
      </ProductWiseReportContext.Provider>
    </KTCard>
  )
}

export default ProductWiseReport
